/*
路由配置文件

路由结构:
┌─────────────────────────────────────────────────────────────────────┐
│                        前端路由配置                                 │
├─────────────────────────────────────────────────────────────────────┤
│  前台页面 (用户访问):                                               │
│    /              → Home.vue              (首页)                    │
│    /text          → TextGenerator.vue     (文案创作入口)              │
│    /image         → ImageGenerator.vue    (图片生成入口)              │
│    /video         → VideoGenerator.vue    (视频生成入口)              │
│    /drama         → Drama.vue             (短剧创作入口)              │
│    /code          → Code.vue              (代码生成)                  │
│    /openclaw      → OpenClaw.vue          (OpenClaw工具)              │
│    /history       → History.vue           (历史记录)                  │
│    /price         → Price.vue             (价格页面)                  │
│    /subscribe     → Subscribe.vue         (订阅页面)                  │
│    /login         → Login.vue             (登录页面)                  │
│    /pay-success   → PaySuccess.vue        (支付成功)                  │
├─────────────────────────────────────────────────────────────────────┤
│  Pro生成器页面 (独立布局):                                           │
│    /text-generator-pro  → GeneratorPro.vue (高级文案生成器)            │
│    /image-generator     → GeneratorPro.vue (高级图片生成器)            │
│    /video-generator-pro → GeneratorPro.vue (高级视频生成器)            │
│    /drama-generator-pro → GeneratorPro.vue (高级短剧生成器)            │
├─────────────────────────────────────────────────────────────────────┤
│  后台管理页面 (需登录):                                              │
│    /admin/dashboard           → Dashboard.vue        (仪表盘)         │
│    /admin/generate-image      → GenerateImage.vue    (图片配置)       │
│    /admin/generate-video      → GenerateVideo.vue    (视频配置)       │
│    /admin/member-list         → MemberList.vue       (用户列表)       │
│    /admin/member-level        → MemberLevel.vue      (会员等级)       │
│    /admin/model-list          → ModelList.vue        (模型管理)       │
│    /admin/model-category      → ModelCategory.vue    (模型分类)       │
│    /admin/payment-alipay      → PaymentAlipay.vue    (支付宝配置)     │
│    /admin/payment-wechat      → PaymentWechat.vue    (微信支付配置)   │
│    /admin/payment-union       → PaymentUnion.vue     (银联配置)       │
│    /admin/site-basic          → SiteBasic.vue        (网站基本设置)   │
│    /admin/site-seo           → SiteSeo.vue          (SEO设置)        │
│    /admin/ad-setting          → AdSetting.vue        (广告设置)       │
│    /admin/admin-setting       → AdminSetting.vue     (管理员设置)     │
│    /admin/attachment-storage  → AttachmentStorage.vue(存储设置)       │
│    /admin/attachment-email    → AttachmentEmail.vue (邮件设置)       │
│    /admin/download-management → DownloadManagement.vue(下载管理)     │
│    /admin/text-config         → TextConfig.vue       (文案配置)       │
│    /admin/drama-config        → DramaConfig.vue      (短剧配置)       │
│    /admin/subscription-config → SubscriptionConfig.vue(订阅配置)     │
│    /admin/order-list          → OrderList.vue        (订单列表)       │
│    /admin/aspect-ratio-config → AspectRatioConfig.vue(比例配置)      │
│    /admin/generate-history    → GenerateHistory.vue  (生成历史)       │
└─────────────────────────────────────────────────────────────────────┘
*/

import Vue from 'vue'
import VueRouter from 'vue-router'

// 导入页面组件
import Home from '../views/Home.vue'
import ImageGenerator from '../views/ImageGenerator.vue'
import VideoGenerator from '../views/VideoGenerator.vue'
import Login from '../views/Login.vue'
import Admin from '../views/Admin.vue'
import Code from '../views/Code.vue'
import Drama from '../views/Drama.vue'
import OpenClaw from '../views/OpenClaw.vue'
import History from '../views/History.vue'
import PaySuccess from '../views/PaySuccess.vue'
import PaymentSuccess from '../views/PaymentSuccess.vue'
import PaymentFailed from '../views/PaymentFailed.vue'
import TextGenerator from '../views/TextGenerator.vue'
import GeneratorPro from '../views/GeneratorPro.vue'
import Price from '../views/Price.vue'
import Subscribe from '../views/Subscribe.vue'
import Profile from '../views/Profile.vue'
import Terms from '../views/Terms.vue'
import Privacy from '../views/Privacy.vue'

// 导入管理员页面组件
import Dashboard from '../views/admin/Dashboard.vue'
import GenerateImage from '../views/admin/GenerateImage.vue'
import GenerateVideo from '../views/admin/GenerateVideo.vue'
import MemberList from '../views/admin/MemberList.vue'
import ModelList from '../views/admin/ModelList.vue'
import ModelCategory from '../views/admin/ModelCategory.vue'
import PaymentAlipay from '../views/admin/PaymentAlipay.vue'
import PaymentWechat from '../views/admin/PaymentWechat.vue'
import PaymentUnion from '../views/admin/PaymentUnion.vue'
import SiteBasic from '../views/admin/SiteBasic.vue'
import SiteSeo from '../views/admin/SiteSeo.vue'
import AdSetting from '../views/admin/AdSetting.vue'
import AdminSetting from '../views/admin/AdminSetting.vue'
import AdminAdd from '../views/admin/AdminAdd.vue'
import AdminPermission from '../views/admin/AdminPermission.vue'
import AttachmentStorage from '../views/admin/AttachmentStorage.vue'
import AttachmentEmail from '../views/admin/AttachmentEmail.vue'
import TextConfig from '../views/admin/TextConfig.vue'
import DramaConfig from '../views/admin/DramaConfig.vue'
import SubscriptionConfig from '../views/admin/SubscriptionConfig.vue'
import OrderList from '../views/admin/OrderList.vue'
import AspectRatioConfig from '../views/admin/AspectRatioConfig.vue'
import GenerateHistory from '../views/admin/GenerateHistory.vue'

// 注册路由插件
Vue.use(VueRouter)

// 路由配置数组
const routes = [
  // 首页
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  // 图片生成入口页
  {
    path: '/image',
    name: 'ImageGenerator',
    component: ImageGenerator
  },
  // 视频生成入口页
  {
    path: '/video',
    name: 'VideoGenerator',
    component: VideoGenerator
  },
  // 高级视频生成器 (独立布局)
  {
    path: '/video-generator-pro',
    name: 'VideoGeneratorPro',
    component: GeneratorPro
  },
  // 高级文案生成器 (独立布局)
  {
    path: '/text-generator-pro',
    name: 'TextGeneratorPro',
    component: GeneratorPro
  },
  // 高级图片生成器 (独立布局)
  {
    path: '/image-generator',
    name: 'ImageGeneratorPro',
    component: GeneratorPro
  },
  // 高级短剧生成器 (独立布局)
  {
    path: '/drama-generator-pro',
    name: 'DramaGeneratorPro',
    component: GeneratorPro
  },
  // 代码生成
  {
    path: '/code',
    name: 'Code',
    component: Code
  },
  // 短剧创作入口页
  {
    path: '/drama',
    name: 'Drama',
    component: Drama
  },
  // OpenClaw工具
  {
    path: '/openclaw',
    name: 'OpenClaw',
    component: OpenClaw
  },
  // 历史记录
  {
    path: '/history',
    name: 'History',
    component: History
  },
  // 价格页面
  {
    path: '/price',
    name: 'Price',
    component: Price
  },
  // 订阅页面
  {
    path: '/subscribe',
    name: 'Subscribe',
    component: Subscribe
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { requiresAuth: true }
  },
  // 文案创作入口页
  {
    path: '/text',
    name: 'TextGenerator',
    component: TextGenerator
  },
  // 登录页面
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  // 用户协议页面
  {
    path: '/terms',
    name: 'Terms',
    component: Terms
  },
  // 隐私政策页面
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy
  },
  // 支付成功页面
  {
    path: '/pay-success',
    name: 'PaySuccess',
    component: PaySuccess
  },
  // 支付成功页面（新版）
  {
    path: '/payment-success',
    name: 'PaymentSuccess',
    component: PaymentSuccess
  },
  // 支付失败页面
  {
    path: '/payment-failed',
    name: 'PaymentFailed',
    component: PaymentFailed
  },
  // 后台管理路由 (嵌套路由)
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    redirect: '/admin/dashboard',  // 默认跳转到仪表盘
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard
      },
      {
        path: 'generate-image',
        name: 'GenerateImage',
        component: GenerateImage
      },
      {
        path: 'generate-video',
        name: 'GenerateVideo',
        component: GenerateVideo
      },
      {
        path: 'member-list',
        name: 'MemberList',
        component: MemberList
      },
      {
        path: 'model-list',
        name: 'ModelList',
        component: ModelList
      },
      {
        path: 'model-category',
        name: 'ModelCategory',
        component: ModelCategory
      },
      {
        path: 'payment-alipay',
        name: 'PaymentAlipay',
        component: PaymentAlipay
      },
      {
        path: 'payment-wechat',
        name: 'PaymentWechat',
        component: PaymentWechat
      },
      {
        path: 'payment-union',
        name: 'PaymentUnion',
        component: PaymentUnion
      },
      {
        path: 'site-basic',
        name: 'SiteBasic',
        component: SiteBasic
      },
      {
        path: 'site-seo',
        name: 'SiteSeo',
        component: SiteSeo
      },
      {
        path: 'ad-setting',
        name: 'AdSetting',
        component: AdSetting
      },
      {
        path: 'admin-setting',
        name: 'AdminSetting',
        component: AdminSetting
      },
      {
        path: 'admin-add',
        name: 'AdminAdd',
        component: AdminAdd
      },
      {
        path: 'admin-permission',
        name: 'AdminPermission',
        component: AdminPermission
      },
      {
        path: 'attachment-storage',
        name: 'AttachmentStorage',
        component: AttachmentStorage
      },
      {
        path: 'attachment-email',
        name: 'AttachmentEmail',
        component: AttachmentEmail
      },
      {
        path: 'download-management',
        name: 'DownloadManagement',
        component: () => import('../views/admin/DownloadManagement.vue')
      },
      {
        path: 'text-config',
        name: 'TextConfig',
        component: TextConfig
      },
      {
        path: 'drama-config',
        name: 'DramaConfig',
        component: DramaConfig
      },
      {
        path: 'subscription-config',
        name: 'SubscriptionConfig',
        component: SubscriptionConfig
      },
      {
        path: 'order-list',
        name: 'OrderList',
        component: OrderList
      },
      {
        path: 'aspect-ratio-config',
        name: 'AspectRatioConfig',
        component: AspectRatioConfig
      },
      {
        path: 'generate-history',
        name: 'GenerateHistory',
        component: GenerateHistory
      }
    ]
  }
]

// 创建路由实例
const router = new VueRouter({
  mode: 'hash',  // 使用hash模式，避免服务器配置问题
  routes
})

router.beforeEach((to, from, next) => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
  const isAuthenticated = !!userInfo.id

  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login')
    return
  }

  if (to.path.startsWith('/admin')) {
    const token = localStorage.getItem('token')
    if (!token) {
      next('/login')
      return
    }
  }
  next()
})

export default router